import { lazy, Suspense } from "react";
import Navbar from "@/components/sr22/Navbar";
import HeroSection from "@/components/sr22/HeroSection";
import TrustBar from "@/components/sr22/TrustBar";
import CookieBanner from "@/components/sr22/CookieBanner";
import MobileCTABar from "@/components/sr22/MobileCTABar";
import SEOHead from "@/components/SEOHead";
const QuizAssistant = lazy(() => import("@/components/sr22/QuizAssistant"));

// Lazy load below-fold sections
const ContentPillar = lazy(() => import("@/components/sr22/ContentPillar"));
const NonOwnerSection = lazy(() => import("@/components/sr22/NonOwnerSection"));
const StatesSection = lazy(() => import("@/components/sr22/StatesSection"));
const TestimonialsSection = lazy(() => import("@/components/sr22/TestimonialsSection"));
const Footer = lazy(() => import("@/components/sr22/Footer"));

const homeFaqs = [
  { question: "¿Cuánto tiempo debo mantener el SR-22?", answer: "La mayoría de estados exigen mantenerlo entre 2 y 5 años. Si cancelas el seguro antes de que termine el periodo, la aseguradora notifica al DMV y tu licencia puede ser re-suspendida inmediatamente." },
  { question: "¿El SR-22 es lo mismo en todos los estados?", answer: "El proceso es similar, pero los requisitos de cobertura mínima varían por estado. Algunos estados como Florida y Virginia usan el FR-44 para DUI, que exige cobertura significativamente más alta. Massachusetts no usa SR-22 y New York usa el formulario FS-1." },
  { question: "¿Puedo obtener SR-22 si no soy ciudadano o residente?", answer: "Sí. El SR-22 no requiere ciudadanía ni residencia permanente. Trabajamos con personas indocumentadas, con ITIN o sin número de seguro social en todos los estados." },
  { question: "¿Qué pasa si me mudo a otro estado y tengo SR-22?", answer: "Debes cumplir con los requisitos del estado que ordenó el SR-22 original. En muchos casos, tu nueva aseguradora en el nuevo estado puede presentar el SR-22 ante el estado anterior." },
  { question: "¿Cuál es la diferencia entre SR-22 y FR-44?", answer: "El FR-44 solo se usa en Florida y Virginia y exige cobertura mucho más alta que el SR-22 estándar (hasta $100,000/$300,000 en lesiones corporales). Se aplica específicamente a condenas por DUI en esos estados." },
  { question: "¿Cuánto cuesta el SR-22?", answer: "El costo del formulario SR-22 en sí es bajo ($15–$50), pero tu prima de seguro aumentará significativamente (entre un 30% y un 300%) porque eres clasificado como conductor de alto riesgo. Comparar entre aseguradoras puede ahorrarte cientos de dólares al año." },
];

const organizationSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://segurosr22usa.com/#organization",
      "name": "SeguroSR22USA",
      "url": "https://segurosr22usa.com/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://segurosr22usa.com/favicon.png"
      },
      "description": "Portal informativo independiente sobre el certificado SR-22 para la comunidad hispana en EE.UU.",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "info@segurosr22usa.com",
        "contactType": "customer support",
        "availableLanguage": "Spanish"
      }
    },
    {
      "@type": "Person",
      "@id": "https://segurosr22usa.com/#founder",
      "name": "Estiven Gabriel Aguiluz Suazo",
      "jobTitle": "Fundador",
      "worksFor": {
        "@id": "https://segurosr22usa.com/#organization"
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://segurosr22usa.com/#website",
      "url": "https://segurosr22usa.com/",
      "name": "SeguroSR22USA",
      "publisher": {
        "@id": "https://segurosr22usa.com/#organization"
      }
    }
  ]
};

export default function Index() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <SEOHead
        title="Seguro SR-22 en USA en Español | SeguroSR22USA.com"
        description="Guías en español para obtener tu SR-22 barato en USA. Compara aseguradoras, precios por estado y recupera tu licencia hoy. DUI, sin crédito, non-owner y más."
        canonical="https://segurosr22usa.com/"
        faqs={homeFaqs}
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <div className="container mx-auto px-4 sm:px-6 py-8 max-w-xl">
          <QuizAssistant />
        </div>
        <Suspense fallback={null}>
          <ContentPillar />
          <NonOwnerSection />
          <TestimonialsSection />
          <StatesSection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
      <CookieBanner />
      <MobileCTABar />
    </>
  );
}
